import { createFileRoute } from "@tanstack/react-router";

/** One pod, open, with no episode selected. The page is `pods.tsx`'s. */
export const Route = createFileRoute("/_console/production/pods/$podId/")({
  component: () => null,
});
